<template>
  <section v-show="inCart">
    <div class="view-cart" @click="viewCart">
      <div class="header">{{ isReservation() ? "リスト" : "カート" }}を見る</div>
      <div class="price" v-if="totalAmount > 0">
        {{totalAmount}}
        <small>円（税込）</small>
      </div> 
    </div>
  </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import store from "../store";

export default Vue.extend({
  name: "FooterCart",
  store,
  computed: {
    inCart: function() {
      return Object.keys(this.$store.state.cart).length > 0
    },
    totalAmount: function() {
      return Object.values(this.$store.state.cart).reduce((total, item) => {
        return total + item.totalAmount
      },0)
    }
  },
  methods: {
    isReservation() {
      //来店予約でかつ商品が存在する場合
      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if (tenantCart && tenantCart.orderType == 3) {
          return true;
        }
      }
      return false;
    },
    viewCart() {
      if (this.isReservation()) {
        this.$router.push('/mobileorder/checkout');
      } else {
        this.$router.push('/mobileorder/cart');
      }

    }
  }
})
</script>

